import { render } from "./SuggestCustomerGroup.vue?vue&type=template&id=818209b8"
import script from "./SuggestCustomerGroup.vue?vue&type=script&lang=js"
export * from "./SuggestCustomerGroup.vue?vue&type=script&lang=js"
script.render = render

export default script